module.exports = __webpack_public_path__ + "static/media/Logo143x32.1dddabdd.svg";